import { z } from "zod";

/**
 * Validación de la captura pública de postventa (HU-20). El testimonio exige
 * texto; el referido exige nombre y teléfono (su alta es una cotización de
 * llamada), con email opcional. Espeja la validación del servidor.
 */

export const testimonialSchema = z.object({
  text: z
    .string()
    .trim()
    .min(1, "Contanos tu experiencia")
    .max(1000, "El testimonio no puede exceder 1000 caracteres"),
  allowPublish: z.boolean(),
});

export const referralSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Ingresá el nombre")
    .max(80, "El nombre no puede exceder 80 caracteres"),
  phone: z
    .string()
    .trim()
    .min(5, "Ingresá un teléfono")
    .max(20, "El teléfono no puede exceder 20 caracteres"),
  email: z
    .string()
    .trim()
    .email("Ingresá un email válido")
    .or(z.literal(""))
    .optional(),
  company: z.string().trim().max(120, "Máximo 120 caracteres").optional(),
});

export type TestimonialValues = z.infer<typeof testimonialSchema>;
export type ReferralValues = z.infer<typeof referralSchema>;
